import React from 'react';
type StatusBadgeProps = {
  children: React.ReactNode;
  tone?: 'light' | 'dark';
  className?: string;
};
export function StatusBadge({
  children,
  tone = 'light',
  className = ''
}: StatusBadgeProps) {
  const toneClass = tone === 'dark' ? 'border-white/30 text-white bg-white/10' : 'border-navy/20 text-navy bg-surface-muted';
  return <span className={`inline-flex items-center gap-2 border rounded-md px-2.5 py-1 text-xs font-semibold whitespace-nowrap ${toneClass} ${className}`} data-id="element-592" data-mp="1te4idn92c1jy">
      <span className="sr-only" data-id="element-593" data-mp="22bonx8dykk0d">Status: </span>
      {children}
    </span>;
}